import React from "react";

export default (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 290.5 290.5">
    <path
      fill={props.color}
      d="M74 66.001h209c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5H74a7.5 7.5 0 000 15zM283 138H74a7.5 7.5 0 000 15h209a7.5 7.5 0 007.5-7.5 7.5 7.5 0 00-7.5-7.5zM283 224.999H74a7.5 7.5 0 000 15h209c4.143 0 7.5-3.358 7.5-7.5s-3.357-7.5-7.5-7.5zM26 32.501c-14.336 0-26 11.664-26 26s11.664 26 26 26 26-11.664 26-26-11.664-26-26-26zm0 37c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM26 119.5c-14.336 0-26 11.664-26 26s11.664 26 26 26 26-11.664 26-26-11.664-26-26-26zm0 37c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11zM26 205.999c-14.336 0-26 11.664-26 26s11.664 26 26 26 26-11.664 26-26-11.664-26-26-26zm0 37c-6.075 0-11-4.925-11-11s4.925-11 11-11 11 4.925 11 11-4.925 11-11 11z"
    />
  </svg>
);

// https://www.flaticon.com/authors/freepik
